import React, { useState, useContext } from 'react';
import axios from 'axios';
import { styled } from '@this/constants/themes';
import { Box, Button, Link } from '@material-ui/core';
import AppointContext from '@this/components/appoint/appoint_context';
import { Coachmark } from '@this/components/appoint/shared/coachmark';

interface Props {
  newAdjustmentButtonRef: React.MutableRefObject<null>;
  menuButtonRef: React.MutableRefObject<null>;
}

const DashboardCoachMark: React.FC<Props> = ({ newAdjustmentButtonRef, menuButtonRef }: Props) => {
  const initialNumber = 0;
  const lastNumber = 1;
  const [activatedNumber, setActivateNumber] = useState<number>(initialNumber);

  const contextValue = useContext(AppointContext);

  const updateUser = async () => {
    const user = contextValue.user;
    if (user) {
      const params = { user: { need_appoint_dashboard_coach_mark: false } };
      await axios.put('/aicalendar/user', params);
      // contextを更新
      contextValue.onUserSignedIn();
    }
  };

  const NextButton = (
    <CoachMarkNextButton
      variant="contained"
      color="primary"
      onClick={e => {
        setActivateNumber(activatedNumber + 1);
        if (activatedNumber === lastNumber) {
          const button = menuButtonRef.current! as HTMLButtonElement;
          button.click();
          updateUser();
        }
      }}
    >
      {activatedNumber === lastNumber ? 'サービス連携へ進む' : '次へ'}
    </CoachMarkNextButton>
  );
  const EndLink = (
    <EndLinkText>
      終了するには
      <Link
        onClick={() => {
          setActivateNumber(lastNumber + 1);
          updateUser();
        }}
        style={{ cursor: 'pointer' }}
      >
        ここをクリック
      </Link>
    </EndLinkText>
  );

  const NewAdjustmentCoachMark = (
    <CoachMarkWrap>
      <CoachMarkTitle>新規予定の作成</CoachMarkTitle>
      <CoachMarkDescription>
        曜日会議の長さを設定するだけで、
        <br />
        スケジュールに合わせて日程候補をAIが提案。
      </CoachMarkDescription>
      <CoachMarkFooter>
        {EndLink}
        {NextButton}
      </CoachMarkFooter>
    </CoachMarkWrap>
  );
  const MenuCoachMark = (
    <CoachMarkWrap>
      <CoachMarkTitle>
        <TitleMark>new!</TitleMark>各種サービスとの連携の設定
      </CoachMarkTitle>
      <CoachMarkDescription>
        「サービス連携」ページから各種サービスとの連携が可能に。
        <br />
        よりスムーズにAIカレンダーをご利用できます。
      </CoachMarkDescription>
      <AlignedServicesDescription>
        【現在連携可能なサービス】
        <br />
        <img src="/images/aicalendar/aligned_services.png" alt="zoom, google meet, slack" />
      </AlignedServicesDescription>
      <CoachMarkFooter>
        {EndLink}
        {NextButton}
      </CoachMarkFooter>
    </CoachMarkWrap>
  );

  const coachList: React.ComponentProps<typeof Coachmark>[] = [
    {
      show: activatedNumber === initialNumber,
      renderContent: () => NewAdjustmentCoachMark,
      targetRef: newAdjustmentButtonRef,
      popupPlacement: 'right'
    },
    {
      show: activatedNumber === lastNumber,
      renderContent: () => MenuCoachMark,
      targetRef: menuButtonRef,
      popupPlacement: 'left'
    }
  ];
  const coach = coachList[activatedNumber];

  return coach ? <Coachmark {...coach} /> : null;
};

const CoachMarkWrap = styled(Box)`
  padding: 10px;
`;

const CoachMarkTitle = styled.p`
  color: #243565;
  font-weight: bold;
  margin: 0 0 10px;
`;

const CoachMarkDescription = styled.p`
  font-size: 11px;
  margin: 0 0 20px;
`;

const CoachMarkFooter = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const CoachMarkNextButton = styled(Button)`
  margin-left: auto;
`;

const EndLinkText = styled.span`
  font-size: 11px;
  margin-right: 20px;
`;

const TitleMark = styled.span`
  color: #bf0000;
  margin-right: 8px;
`;

const AlignedServicesDescription = styled.p`
  font-size: 10px;
  margin: 0 0 20px;
`;

export default DashboardCoachMark;
